<template>
  <div>
    <form id="signup-form" @submit.prevent="processForm">
      <!-- name -->
      <div class="field">
        <label class="label">Name</label>
        <input type="text" class="input" name="name" v-model="name" />
      </div>

      <!-- email -->
      <div class="field">
        <label class="label">Email</label>
        <input type="email" class="input" name="email" v-model="email" />
      </div>

      <!-- submit button -->
      <div class="field has-text-right">
        <button type="submit" class="button is-danger">Submit</button>
      </div>
    </form>
  </div>
</template>

<script>

export default {
  name: "Create",
  data: function() {
    return {
      name: null,
      email: null
    };
  },

  methods: {
    processForm() {
      this.processFormAsync(this.name, this.email);
    },
    async processFormAsync(name, email) {
      console.log(name)
      console.log(email)
      this.$apiNoAuthenticated
        .post("/user/create", {
          name: name,
          email: email
        })
        .then(function(response) {
          console.log(response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>